__turbopack_context__.v({
  "bodyCopy": "ImageSection-module__0HAs5W__bodyCopy" + " " + __turbopack_context__.i(515534)["sectionBody"],
  "desktopImage": "ImageSection-module__0HAs5W__desktopImage",
  "heading": "ImageSection-module__0HAs5W__heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "imageWrapper": "ImageSection-module__0HAs5W__imageWrapper",
  "mobileImage": "ImageSection-module__0HAs5W__mobileImage",
  "section": "ImageSection-module__0HAs5W__section",
  "textContainer": "ImageSection-module__0HAs5W__textContainer",
  "tintOverlay": "ImageSection-module__0HAs5W__tintOverlay",
});
